import React, { useState, useEffect } from 'react';
import { LoginHistoryEntry } from '../../types/user';
import { fetchLoginHistory } from '../../services/profileService';

export default function Security() {
  const [history, setHistory] = useState<LoginHistoryEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchLoginHistory()
      .then(setHistory)
      .catch((err: any) => setError(err.message || 'Failed to load security info'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="profile-section">
      <h3 className="profile-section-title">Security</h3>

      <div className="security-actions">
        <button className="btn-secondary">Change Password</button>
        <button className="btn-secondary">Enable 2FA</button>
      </div>

      <h4 className="profile-subsection-title">Login History</h4>
      {loading && <div className="profile-loading">Loading login history…</div>}
      {error && <div className="profile-error">{error}</div>}
      {!loading && !error && history.length === 0 && (
        <p className="profile-empty">No login history available.</p>
      )}
      {history.length > 0 && (
        <table className="profile-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>IP Address</th>
              <th>Device</th>
              <th>Result</th>
            </tr>
          </thead>
          <tbody>
            {history.map(h => (
              <tr key={h.id}>
                <td>{new Date(h.createdAt).toLocaleString()}</td>
                <td>{h.ipAddress}</td>
                <td className="user-agent-cell">{h.userAgent}</td>
                <td>
                  <span className={`status-badge ${h.success ? 'status-completed' : 'status-failed'}`}>
                    {h.success ? 'Success' : 'Failed'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
